module.exports = __webpack_public_path__ + "img/health_bg.32efd00.png";